<app-header></app-header>
<app-home>s</app-home>
<!-- routes will be rendered here -->
<router-outlet></router-outlet>

<app-footer></app-footer>